/** `<field>__in`, or `<field>__not_in` when that filter is in "Excluding" mode (everything except the selection). */
export const inOrNotIn = (field: string, excluded: boolean): string => field + (excluded ? '__not_in' : '__in');
